import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/faqs'
import actions from '../actions/help'

class Container extends React.Component {

  static displayName = 'Faqs.container'

  constructor(props) {
    super(props)

    const id = parseInt(props.match.params.id, 10)

    if (props.categories.length > 0) {
      props.fetchFaqs(id)
    } else {
      props.fetchCategories()
        .then(() => {
          props.fetchFaqs(id)
        })
    }
  }

  render() {
    return <Component {...this.props} />
  }

  static propTypes = {
    categories: PropTypes.array.isRequired,
    selectedCategory: PropTypes.object,
    fetchCategories: PropTypes.func.isRequired,
    fetchFaqs: PropTypes.func.isRequired,
  }
}


const mapStateToProps = state => {
  const data = state.ui.help.help
  return {
    error: data.get('error'),
    loading: data.get('loadingFaqs') || data.get('loadingCategories'),
    categories: data.get('categories').toArray(),
    selectedCategory: data.get('categories').toArray().find(c => c.ID === data.get('selectedCategory')),
    faqs: data.get('faqs').toArray(),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchCategories: () => dispatch(actions.fetchCategories()),
    fetchFaqs: (categoryID) => dispatch(actions.fetchFaqs(categoryID)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/help/containers/faqs.js